import { render, staticRenderFns } from "./EditPlayer.vue?vue&type=template&id=fb6647a4&scoped=true&"
import script from "./EditPlayer.vue?vue&type=script&lang=js&"
export * from "./EditPlayer.vue?vue&type=script&lang=js&"
import style0 from "./EditPlayer.vue?vue&type=style&index=0&id=fb6647a4&scoped=true&lang=css&"
import style1 from "./EditPlayer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6647a4",
  null
  
)

export default component.exports